import script from "./AccPayBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccPayBanner.vue?vue&type=script&lang=ts&setup=true"

import "./AccPayBanner.vue?vue&type=style&index=0&id=103466c3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-103466c3"]])

export default __exports__